var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayBkash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 59.4 26.4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.7705 12.603L42.4096 19.9595L53.1362 14.5379L40.7705 12.603Z",
    fill: "var(--fill-0, #D12053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.82 1.60986L40.7715 12.6042L53.1384 14.5378L43.82 1.60986Z",
    fill: "var(--fill-0, #E2136E)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.7156 0.000195313L43.5078 1.52565L40.4832 12.4545L30.7156 0.000195313Z",
    fill: "var(--fill-0, #D12053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.6162 2.14906H32.0408L36.0369 7.25069L30.6162 2.14906Z",
    fill: "var(--fill-0, #9E1638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53.4761 14.4676L49.7588 9.33199L55.7726 8.2575L53.4761 14.4676Z",
    fill: "var(--fill-0, #D12053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.8555 15.9726L53.2391 14.8301L43.8525 19.584L52.8555 15.9726Z",
    fill: "var(--fill-0, #E2136E)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.5069 12.8926L42.4652 21.6812L36.6533 26.3999L40.5069 12.8926Z",
    fill: "var(--fill-0, #9E1638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.1875 10.8671L58.6007 10.8092L56.1339 8.30371L55.1875 10.8671Z",
    fill: "var(--fill-0, #E2136E)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.5762 10.5158V11.4644C31.2279 10.9164 30.2487 10.5549 29.7087 10.6305C29.1686 10.706 28.3207 11.152 27.8601 12.1421C27.3554 11.1003 26.3864 10.4932 25.6633 10.4932H23.4199V11.6067H24.881C25.5271 11.6067 26.2009 11.5412 26.804 12.0892C27.0384 12.315 27.1918 12.6116 27.2406 12.9331C27.4261 13.7973 27.0463 14.834 26.0406 14.8592C25.7218 14.8713 25.4031 14.8343 25.0955 14.7496L25.0186 14.8289C25.2495 15.1567 25.4565 15.5007 25.6381 15.8581C26.2383 15.7303 26.7887 15.432 27.2229 14.999C27.4883 14.7412 27.7042 14.4373 27.8601 14.1021C27.9952 14.4317 28.1869 14.7353 28.4267 14.999C28.8052 15.4225 29.3031 15.7219 29.8551 15.8581C30.0179 15.503 30.2042 15.1592 30.4128 14.8289L30.3446 14.7496C30.0695 14.8341 29.7818 14.8712 29.4942 14.8592C28.4532 14.8302 28.2627 13.7645 28.4242 12.9331C28.5642 12.2252 29.1951 11.5286 29.8122 11.477C30.5049 11.4203 31.3503 12.0035 31.5219 12.7177C31.6093 13.1093 31.6516 13.5095 31.6481 13.9106V20.3966C31.8128 20.3713 31.9787 20.3553 32.1452 20.3488C32.3143 20.3547 32.4828 20.3707 32.65 20.3966V10.5158H31.5762Z",
    fill: "var(--fill-0, #231F20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.72653 6.75104C6.4817 6.57595 9.17691 8.83704 9.3952 9.33083L9.56176 9.30438V8.00566C8.32898 7.35442 6.60788 6.01666 4.32528 6.18041C1.79284 6.3618 0.802322 7.84821 0.799798 10.4633V20.4033C0.956919 20.3747 1.1159 20.3574 1.2755 20.3516C1.45595 20.3583 1.63586 20.3755 1.81429 20.4033V11.6121H8.54727V12.3339C4.85145 12.4019 3.2477 14.4589 3.2477 16.2262C3.2477 18.3802 5.47604 20.4045 9.39016 20.4045H9.56302V10.4935H1.90766L1.89504 10.4708C1.84705 10.2787 1.82123 10.0818 1.81807 9.88382C1.80419 8.20973 2.9171 6.92739 4.72653 6.75104ZM4.56881 16.2879C4.56881 14.7335 6.29369 13.2433 8.54727 12.9196V19.9851C6.07161 19.5631 4.56881 17.6232 4.56881 16.2879Z",
    fill: "var(--fill-0, #E2136E)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.8252 10.4932V11.608H16.75V12.3298C13.0542 12.3978 11.4504 14.4548 11.4504 16.2221C11.4504 18.3761 13.68 20.4004 17.5916 20.4004H17.7632V13.0541H17.8705C19.1133 13.02 19.8565 13.8099 19.8956 14.8239C19.9112 15.1792 19.8134 15.5303 19.6164 15.8266C19.4193 16.1229 19.1332 16.3491 18.7991 16.4728L18.8067 16.6227L19.7505 16.595C20.278 15.9286 20.6199 15.1854 20.5859 14.383C20.5278 12.9835 19.5916 12.3172 17.7632 12.3423V11.618H22.148V20.4092C22.3118 20.3804 22.4776 20.3632 22.6439 20.3576C22.8172 20.3645 22.9899 20.3818 23.1612 20.4092V10.4932H9.8252ZM12.7715 16.2876C12.7715 14.7332 14.4977 13.243 16.75 12.9193V19.986C14.2731 19.5627 12.7715 17.6229 12.7715 16.2876Z",
    fill: "var(--fill-0, #231F20)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4,
    height: 26.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBkash);
export default __webpack_public_path__ + "static/media/pay-bkash.8e0dce71d4f59d35f5faa785b505625c.svg";
export { ForwardRef as ReactComponent };